import react, { useEffect } from 'react';
import {
  shape,
  string,
  useDataModel,
  params,
  customType,
} from '@thd-nucleus/data-sources';
import { useNavigate } from '@thd-olt-component-react/router';
import { staticPageUrls } from '../utils/consts';
import { getTmxId, isLocalHost } from '../utils/utils';

const RequestContext = shape({
  tmxProfileId: string(),
  experience: shape({
    type: string(),
    component: string(),
  }),
});

const useAuth = () => {
  const requestContext = customType('RequestContext').shape(RequestContext);
  const navigate = useNavigate();

  const opts = {
    dataModel: { validateSession: params({ requestContext }).string() },
    variables: {
      requestContext: {
        tmxProfileId: getTmxId(),
        experience: {
          type: 'GC_R',
          component: 'balanceCheck',
        },
      },
    },
  };
  const { data, loading, error } = useDataModel('validateSession', opts);

  const goToAuth = () => {
    if (isLocalHost()) {
      return;
    }
    setTimeout(() => navigate(staticPageUrls.auth.url), 100);
  };

  useEffect(() => {
    if (!loading && error) {
      goToAuth();
    }
  }, [loading, error]);

  return {
    goToAuth,
    data,
    loading
  };
};

export default useAuth;